import { Translations } from '../shared/i18n';

export const contactTranslations: Translations = {
  en: {
    // Contact Page SEO
    contactSeoTitle: "KontoMatch | Contact Us",
    contactSeoDesc: "Get in touch with the KontoMatch team. We're here to help with any questions, feedback, or ideas you have about tax-ready bookkeeping.",

    // Contact Page Hero
    contactTitle: "We'd Love to Hear From You",

    navContactUs: "Contact Us",

    // Shared Contact Section
    contactSectionHeading1: "Got an idea, feedback, or a question?",
    contactSectionHeading2: "We read everything.",
    contactSectionSuccess: "Thanks for reaching out! We'll get back to you soon.",

    contactFormNameSpace: "Name",
    contactFormEmailSpace: "Email",
    contactFormMessageSpace: "Message",
    contactFormSubmit: "Send Message",
    contactFormSubmitting: "Sending...",

    contactFormErrRequired: "Please fill in all fields.",
    contactFormErrEmail: "Please enter a valid email address.",
    contactFormErrGeneric: "Something went wrong. Please try again later.",
  },

  de: {
    contactSeoTitle: "KontoMatch | Kontaktieren Sie uns",
    contactSeoDesc: "Kontaktieren Sie das KontoMatch-Team. Wir sind hier, um bei Fragen, Feedback oder Ideen zur steuerfertigen Buchhaltung zu helfen.",

    contactTitle: "Wir freuen uns, von Ihnen zu hören",

    navContactUs: "Kontakt",

    contactSectionHeading1: "Eine Idee, Feedback oder eine Frage?",
    contactSectionHeading2: "Wir lesen alles.",
    contactSectionSuccess: "Danke für deine Nachricht! Wir melden uns bald.",

    contactFormNameSpace: "Name",
    contactFormEmailSpace: "E-Mail",
    contactFormMessageSpace: "Nachricht",
    contactFormSubmit: "Nachricht senden",
    contactFormSubmitting: "Wird gesendet...",

    contactFormErrRequired: "Bitte fülle alle Felder aus.",
    contactFormErrEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
    contactFormErrGeneric: "Etwas ist schiefgelaufen. Bitte versuche es später erneut.",
  },

  tr: {
    contactSeoTitle: "KontoMatch | İletişim",
    contactSeoDesc: "KontoMatch ekibiyle iletişime geçin. Vergiye hazır muhasebe ile ilgili her türlü sorunuz, geri bildiriminiz veya fikriniz için buradayız.",

    contactTitle: "Sizden Haber Almak İsteriz",

    navContactUs: "İletişim",

    contactSectionHeading1: "Bir fikrin, geri bildiriminiz veya sorunuz mu var?",
    contactSectionHeading2: "Her şeyi okuyoruz.",
    contactSectionSuccess: "İletişime geçtiğin için teşekkürler! En kısa sürede geri döneceğiz.",

    contactFormNameSpace: "Ad",
    contactFormEmailSpace: "E-posta",
    contactFormMessageSpace: "Mesaj",
    contactFormSubmit: "Mesaj Gönder",
    contactFormSubmitting: "Gönderiliyor...",

    contactFormErrRequired: "Lütfen tüm alanları doldur.",
    contactFormErrEmail: "Lütfen geçerli bir e-posta adresi gir.",
    contactFormErrGeneric: "Bir şeyler ters gitti. Lütfen daha sonra tekrar dene.",
  },
};
